import { AddItemsModel, OrderModel, SearchOrderRequestModel } from './order.models';
import { getHttp, getShoppingCartLocal, postHttp } from "shared/plugins/http-service";
import {
  CUSTOMER_ORDER_API, CUSTOMER_ORDER_API_SEARCH, SHOPPING_CART_ADD_ITEMS_API, SHOPPING_WEBSITE_MERGED_CART_API
} from "shared/constants/api-endpoint";
import { PagedResult } from "../paged-result-model";
export const getOrderListApi = async (model: SearchOrderRequestModel) => {
  const response = await postHttp<PagedResult<OrderModel>>(
    `${process.env.REACT_APP_API_URI}${CUSTOMER_ORDER_API_SEARCH}`,model
  );
  return response;
};

export const getOrderApi = async (id: number | string) => {
  const response = await getHttp<OrderModel>(
    `${process.env.REACT_APP_API_URI}${CUSTOMER_ORDER_API}/${id}`
  );
  return response;
};
export const addItemsApi = async (model : AddItemsModel) => {
  const response = await postHttp<OrderModel>(
    `${process.env.REACT_APP_API_URI}${SHOPPING_CART_ADD_ITEMS_API}`,model
  );
  return response;
};

export const mergedCartApi = async (model: OrderModel) => {
  const response = await postHttp(
    `${process.env.REACT_APP_API_URI}${SHOPPING_WEBSITE_MERGED_CART_API}`,model
  );
  return response;
};

